<template>
  <div class="main-container">
    <v-container>
      <v-row class="d-flex justify-center" align="center" dense>
        <!-- Leave Request Form -->
        <v-col cols="12" sm="6" md="5">
          <v-card class="request-leave-card" elevation="3">
            <v-card-title class="red-header">Request Leave</v-card-title>
            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-text-field filled dense rounded v-model="leaveRequest.fullName" label="Full Name" required></v-text-field>
                <v-text-field filled dense rounded v-model="leaveRequest.reason" label="Reason" required></v-text-field>
                <v-menu
                  v-model="menuStartDate"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      filled dense rounded
                      v-model="leaveRequest.startDate"
                      label="Start Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="leaveRequest.startDate" @input="menuStartDate = false"></v-date-picker>
                </v-menu>
                <v-menu
                  v-model="menuEndDate"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      filled dense rounded
                      v-model="leaveRequest.endDate"
                      label="End Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="leaveRequest.endDate" @input="menuEndDate = false"></v-date-picker>
                </v-menu>
              </v-form>
            </v-card-text>
            <v-card-actions class="d-flex justify-space-between">
              <v-btn :disabled="!valid" color="black" width="200px" rounded dark @click="saveRequest">Save</v-btn>
              <v-btn color="black" width="200px" rounded dark @click="dialog = true">Show Request Details</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- Dialog for Leave Request Details -->
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title class="red-header">Leave Request Details</v-card-title>
        <v-card-text>
          <div v-if="savedRequest">
            <div><strong>Full Name:</strong> {{ leaveRequest.fullName }}</div>
            <div><strong>Reason:</strong> {{ savedRequest.reason }}</div>
            <div><strong>Start Date:</strong> {{ savedRequest.startDate }}</div>
            <div><strong>End Date:</strong> {{ savedRequest.endDate }}</div>
            <div><strong>Status:</strong> {{ savedRequest.status }}</div>
          </div>
          <div v-else>
            <p>No leave request saved yet.</p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="red" width="200px" rounded dark @click="deleteRequest">Delete Request</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="black" width="200px" rounded dark @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { getFirestore, collection, addDoc, doc, deleteDoc, query, where, getDocs, getDoc } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { firebaseApp } from "@/firebaseConfig";

const db = getFirestore(firebaseApp);

export default {
  data() {
    return {
      valid: false,
      menuStartDate: false,
      menuEndDate: false,
      dialog: false,
      leaveRequest: {
        uid: "",
        fullName: "",
        reason: "",
        startDate: "",
        endDate: "",
        status: "NotApproved",
      },
      savedRequest: null,
      requestDocId: null,
    };
  },
  async created() {
    const auth = getAuth(firebaseApp);
    const user = auth.currentUser;
    if (user) {
      this.leaveRequest.uid = user.uid;
      await this.fetchUserFullName(user.uid);
      await this.fetchPreviousRequest(user.uid);
    }
  },
  methods: {
    async fetchUserFullName(uid) {
      try {
        const userDoc = await getDoc(doc(db, "users", uid));
        if (userDoc.exists()) {
          this.leaveRequest.fullName = userDoc.data().fullName || "Unknown User";
        } else {
          console.error("No such user document!");
        }
      } catch (e) {
        console.error("Error fetching user full name: ", e);
      }
    },
    async fetchPreviousRequest(uid) {
      try {
        const q = query(collection(db, "Request Leave"), where("uid", "==", uid));
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
          const data = doc.data();
          this.savedRequest = data;
          this.requestDocId = doc.id;
        });
      } catch (e) {
        console.error("Error fetching previous request: ", e);
      }
    },
    async saveRequest() {
      try {
        const docRef = await addDoc(collection(db, "Request Leave"), this.leaveRequest);
        console.log("Document written with ID: ", docRef.id);
        this.savedRequest = { ...this.leaveRequest };
        this.requestDocId = docRef.id;
      } catch (e) {
        console.error("Error adding document: ", e);
      }
    },
    async deleteRequest() {
      if (this.requestDocId) {
        try {
          await deleteDoc(doc(db, "Request Leave", this.requestDocId));
          console.log("Document successfully deleted");
          this.savedRequest = null;
          this.requestDocId = null;
          this.dialog = false;
        } catch (e) {
          console.error("Error deleting document: ", e);
        }
      }
    },
  },
};
</script>

<style scoped>
.main-container {
  background-color: black;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.request-leave-card {
  background-color: white;
  border-radius: 16px;
  width: 100%;
  padding: 16px;
  margin: 16px 0;
}

.red-header {
  text-align: center;
  color: red;
  font-weight: bold;
  font-size: 1.2rem;
}

.v-btn {
  margin: 0 auto;
  display: block;
}

.v-dialog {
  background-color: white;
}

.v-card-title {
  font-weight: bold;
}

.v-card-text div {
  margin-bottom: 8px;
}
</style>
